import messages from './messages';

const promises = {};
let connectedWindow;
const listeners = {};

// eslint-disable-next-line arrow-body-style
const emit = (message) => {
  if (window === window.parent) return Promise.resolve();

  return new Promise((resolve, reject) => {
    const promise = {
      resolve,
      reject,
    };
    const id = `${message.action}-${Date.now()}`;
    promises[id] = promise;

    messages.send(connectedWindow, { ...message, id });
  });
};

const emitSequentially = (messageCollection) =>
  messageCollection.reduce(
    (resolvedPromise, message) => resolvedPromise.then(() => emit(message)),
    Promise.resolve()
  );
const handle = (message) => {
  const eventHandlers = listeners[message.event];

  if (!eventHandlers) {
    return;
  }

  eventHandlers.forEach((handler) => {
    handler(message);
  });
};

const on = (action, callback) => {
  if (!listeners[action]) {
    listeners[action] = [];
  }
  listeners[action].push(callback);
};

const off = (action) => {
  listeners[action] = [];
};

const connect = (sourceWindow, targetWindow) => {
  connectedWindow = targetWindow;

  messages.listen(sourceWindow, handle);

  on('ws:response', (event) => {
    const { id } = event.data;
    if (promises[id]) {
      if (event.data.status === 'resolved') {
        promises[id].resolve(event);
      } else {
        promises[id].reject(event);
      }

      promises[id] = undefined;
    }
  });
};

export default {
  on,
  off,
  emit,
  connect,
  emitSequentially,
};
